<section class="checkbox" [formGroup]="form">
  @if(this.icon) {
      <lib-app-icon class="pr-[10px]" [icon]="this.icon" matSuffix size="48x48" />
  }

  @if(getLabelPosition() === 'before') {
      <div [class]="this.className" class="flex items-center">
          <mat-label [class]="this.labelClassName">{{this.label}}</mat-label>
          <mat-checkbox
                class="mat-checkbox"
                [formControlName]="this.key"
                [id]="this.key"
                [value]="this.label"
                color="primary"
                (change)="this.handleChange($event)"
                [disabled]="this.disabled"
            />
      </div>
  }

  @if(getLabelPosition() === 'after') {
      <div [class]="this.className" class="flex items-center">
          <mat-checkbox
            class="mat-checkbox"
            [formControlName]="this.key"
            [id]="this.key"
            [value]="this.label"
            color="primary"
            (change)="this.handleChange($event)"
            [disabled]="this.disabled"
          />
          <mat-label [class]="this.labelClassName">{{this.label}}</mat-label>
      </div>
  }
</section>